import Vue from "vue"

let client = () => Vue.prototype.$api

export default {
  getAllItemsBySurvey(surveyId) {
    var disabledPagination = true
    return client().get(`/surveys/items/${surveyId}`, {
      params: { disabledPagination }
    })
  },

  postSurveyItemAnswer(answerData) {
    return client().post("/surveys/item-answers", answerData)
  },

  postSurveyAnswer(surveyId) {
    return client().post("/surveys/answers", null, {
      params: { idSurvey: surveyId }
    })
  },

  checkSurveyCompleted(surveyId) {
    return client().get(`/surveys/${surveyId}`)
  },

   getLastAnsweredItem(surveyId) {
    return client().get('/surveys/item-answers', {
      params: { surveyId: surveyId }
    })
  },

  checkBusinessCodesByUser() {
    return client().get('/surveys/users/business')
  },

  checkGroupCodesByUser() {
    return client().get('/surveys/users/groups')
  },
  getSurveyAvailable() {
    return client().get('/survey-available')
  }
}



// WEBPACK FOOTER //
// ./src/repositories/SurveyRepository.js